var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { makeRemoteLoadModules } from '@/main/factories/usecases';
export const useMyModulesStudent = ({ loadKeywords, loadModules }) => {
    const [modules, setModules] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cumulativeScore, setCumulativeScore] = useState(0);
    const [currentProgress, setCurrentProgress] = useState(0);
    const [user, setUser] = useState(null);
    const { idStudent } = useParams();
    useEffect(() => {
        getModules();
    }, []);
    const getModules = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        if (parseInt(idStudent) > 0) {
            const data = yield makeRemoteLoadModules().studentModuleViewList(parseInt(idStudent), '0');
            if (data) {
                setCumulativeScore((data === null || data === void 0 ? void 0 : data.studentScorePercent) || 0);
                setCurrentProgress((data === null || data === void 0 ? void 0 : data.studentProgressPercent) || 0);
                setModules((data === null || data === void 0 ? void 0 : data.modules) || []);
            }
        }
        setLoading(false);
    });
    return {
        loading,
        modules,
        cumulativeScore,
        currentProgress
    };
};
export default useMyModulesStudent;
